import { createSortOption } from "@nosto/preact"

export const SIZES_LENGTH = 5;

export const settings = window?.domaineSettings || {
    'shop_name': 'NOBULL',
    'sibling_collections': [],
    'products_per_page': "24",
    'popular_searches_terms': "women\nsale\nshoes\nlifter\ngolf",
    'search_product_list': [],
    'may_like_products_list_no_results': [],
}

// export const sizes = Array.from({ length: SIZES_LENGTH }, (_, i) => (i + 1) * settings.products_per_page); //[24, 48, 72]
export const sizes = [24]; // Hardcoded to 24

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    createSortOption("-price", "Price: High to Low", { field: "price", order: "desc" }),
    createSortOption("price", "Price: Low to High", { field: "price", order: "asc" }),
    createSortOption("newest", "Newest", { field: "created", order: "desc" }),
    createSortOption("mostPopular", "Most Popular", { field: "best-selling", order: "desc" })
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5,
    showPaginationInfo: false,
    inputCssSelector: "#Search-In-Modal-Nosto",
}
